import React from 'react';
import { State } from 'store/types';
import { useStoreon } from 'storeon/react';
import { getExternalDepsRules, isPathExclude } from './utils';
import { useRouter } from 'common/hooks';
import { withCondition } from './with-condition';
import { useCdpScript } from '../header-layout/hooks/cdp-script';
import { useAppsflyerScript } from '../header-layout/hooks/appsflyer-script/use-appsflyer-script';

interface ExternalDependenciesProps {
  disableAppsflyerByConsumer?: boolean;
}

export const ExternalDependencies = (props: ExternalDependenciesProps) => {
  const { disableAppsflyerByConsumer = false } = props;
  const { model } = useStoreon<State>('model');

  const { disabled, excludeAppsflyerByPatternURL, excludeCdpByPatternURL } = getExternalDepsRules(model);

  const path = useRouter().getPath();

  const excludeAppsflyer = isPathExclude(path, excludeAppsflyerByPatternURL);
  const excludeCdp = isPathExclude(path, excludeCdpByPatternURL);

  const CDPScript = withCondition({ hook: useCdpScript, disabled: disabled || excludeCdp });
  const AppsFlyerScript = withCondition({
    hook: useAppsflyerScript,
    disabled: disabled || disableAppsflyerByConsumer || excludeAppsflyer,
  });

  return (
    <>
      <CDPScript />
      <AppsFlyerScript />
    </>
  );
};
